import React from 'react';
import Link from '@material-ui/core/Link';
import { TypographyProps } from '@material-ui/core/Typography';

interface Props {
  onClick: () => void;
  href: string;
  color?: 'initial' | 'inherit' | 'primary' | 'secondary' | 'textPrimary' | 'textSecondary' | 'error';
  underline?: 'none' | 'hover' | 'always';
  variant?: 'inherit';
  TypographyClasses?: TypographyProps['classes'];
  style?: React.CSSProperties;
}

const CustomLink: React.FC<Props> = ({
  onClick,
  children,
  href,
  color = 'primary',
  underline = 'hover',
  variant = 'inherit',
  TypographyClasses,
  style,
}) => {
  return (
    <Link
      href={href}
      onClick={() => onClick()}
      color={color}
      underline={underline}
      variant={variant}
      TypographyClasses={TypographyClasses}
      style={style}
    >
      {children}
    </Link>
  );
};

export default CustomLink;
